module.exports = __webpack_public_path__ + "img/img-5.87ad0832.png";